<header role="banner">
    <div class="d-flex">
        <!-- Hamburger Menu Component -->
        <button class="hamburger-menu" *ngIf="isCurrentRouteIn('/detail/')" (click)="toggleProzessNavigation()" aria-label="Toggle Navigation Menu"></button>
        
        <!-- Logo Component -->
        <div class="branding" >
            <a class="navbar-brand" routerLink="/overview" translate role="link" [attr.aria-label]="portalName">
                <div class="grid grid-cols-1 lg:grid-cols-2" style="margin-right: 0; max-height: 36px;">
                    <div class="d-flex align-items-end">
                        <img class="logo" [alt]="portalName" src="/assets/ace_logo_xfound_header.png" />
                        <span class="ml-2 by-text">by</span>
                    </div>
                    <img class="logo ml-2" [alt]="portalName" [src]="'/assets/' + brandLogoFileName"/>
                    <!-- <img class="logo_mobile" [alt]="portalName" src="/assets/ace_logo_xfound_header_mobile.png" /> -->
                </div>
            </a>
        </div>
    
        <!-- Navigation Links Component -->

        <nav class="navigation" *ngIf="showLinks">
            <a *ngIf="!isGutachterportal" class="link" routerLink="/overview" routerLinkActive="active" role="button">
                <i class="overview"></i>&nbsp;
                <span class="text" translate>navigation.overview</span>
            </a>
            <a *ngIf="!isGutachterportal" class="link" routerLink="/anfrage" routerLinkActive="active">
                <i class="folder"></i>&nbsp;
                <span class="text" translate>navigation.my_applications</span>
            </a>
            <a *ngIf="isGutachterportal" class="link" routerLink="/review" routerLinkActive="active" role="button">
                <i class="overview"></i>&nbsp;
                <span class="text" translate>navigation.my_reviews</span>
        </a>    
        </nav>
    </div>
    
    <div class="d-flex justify-content-center">
        <div class="navigation mr-2" *ngIf="showChat">
            <a class="link" routerLink="/chat" routerLinkActive="active">
                <i class="chat"></i>
                <span class="text" title="" translate>Chat</span>
            </a>
        </div>

        <kendo-dropdownlist aria-label="language" *ngIf="IsPortalMehrsprachig" [formControl]="languageFormControl" [data]="langsObject" [textField]="'text'" [valueField]="'value'" (valueChange)="switchLang($event.value)"></kendo-dropdownlist>
    
        <!-- User Profile Component --> 
        <div class="ml-4" *ngIf="showUsername">
            <button class="user-link" #anchor (click)="onToggle()" tabIndex="0">
                <span>{{username}}</span>
                <i></i>
            </button>
            <kendo-popup
                #popup  
                [anchor]="{ nativeElement: anchor }"
                (anchorViewportLeave)="show = false"
                [anchorAlign]="anchorAlign"
                [popupAlign]="popupAlign"
                *ngIf="show"
            >
                <div class="content">
                    <span class="user-name">{{ 'navigation.signed_in_as' | translate }} <b>{{username}}</b></span>
                    <button class="logout-link" (click)="logout()" tabIndex="0"><i></i>&nbsp;{{ 'navigation.sign_out' | translate }}  </button>
                </div>
            </kendo-popup>
        </div>  
    </div>  
</header>
